import {init as detailsInit} from './core/details'
import {init as miniCartInit} from './woocommerce/mini-cart'
import {init as checkoutInit} from './woocommerce/checkout'
import {init as addToCartFormInit} from './woocommerce/add-to-cart-form'

document.addEventListener(
	"DOMContentLoaded",
	function () {
		detailsInit();
		miniCartInit();
		checkoutInit();
		addToCartFormInit();
	}
);
